import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CompanyPartner, TokenResponse } from '../models/partner.model';

@Injectable()
export class PartnerService {
  public token: string;
  
  constructor(private http: HttpClient) {
  }

  private getToken():Observable<TokenResponse> {
    return this.http.get<TokenResponse>(`${environment.apiEndpoint}/api/v2/reselling/token`)
      .pipe(
       tap( (token: TokenResponse) => {this.token = token.token} )
      );
  }

  private get headers():HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', `Bearer ${this.token}`);
    return headers;
  }

  public getCompanyPartner(companyId: number) {
    return this.getToken()
      .pipe(
        switchMap((token:TokenResponse) => {
          return this.http.get(`${environment.resellingApi}/api/v1/customers/${companyId}`, { headers: this.headers });
        })
      )
  }
}
